<template>
  <collapse :active-index="0">
    <collapse-item body-classes="p-0 m-0">
      <template slot="title">
        <div class="row align-items-center">
          <div class="col-sm-4">
            <h3 class="mb-0">{{ title }}</h3>
          </div>

          <div class="col text-right mr-5">
            <slot name="actions"></slot>
          </div>
        </div>
      </template>

      <div class="table-responsive">
        <el-table :data="queriedData" header-row-class-name="thead-light" row-key="id" @sort-change="sortChange">
          <el-table-column label="Campaña" min-width="145px" prop="campaign">
            <template #default="{ row }">
              <div class="font-weight-bold">{{ row.campaign.name }}</div>
            </template>
          </el-table-column>

          <el-table-column label="Variedad" min-width="145px" prop="variety">
            <template #default="{ row }">
              <div>{{ row.variety.name }}</div>
            </template>
          </el-table-column>

          <el-table-column label="Cantidad" min-width="145px" prop="quantity">
            <template #default="{ row }">
              <span>{{ row.quantity }}</span
              >&nbsp;
              <span class="font-weight-bold"> ({{ row.variety.crop.unit.toLowerCase() }})</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </collapse-item>
  </collapse>
</template>

<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui';
import PaginationMixin from '@/mixins/paginationMixin';
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

export default {
  name: 'VarietyCampaignTotalsTable',
  components: {
    Collapse,
    CollapseItem,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  mixins: [PaginationMixin],
  props: {
    title: {
      type: String,
      default: 'Totales por variedad',
    },

    seller: {
      type: Number,
      default: null,
    },

    distributor: {
      type: Number,
      default: null,
    },

    producer: {
      type: Number,
      default: null,
    },

    campaign: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      campaigns: [],
      searchKeys: ['variety.name', 'campaign.name', 'campaign.crops.name', 'variety.crop.name', 'quantity'],
      projections: [],
    };
  },

  computed: {
    tableData() {
      return this.projections;
    },
  },

  created() {
    this.fetchResults();
  },

  methods: {
    fetchResults() {
      this.$services
        .resource('projection_statistics')
        .varietyTotals({ 'filter[campaign]': this.campaign })
        .then((res) => res.data.data)
        .then((data) => (this.projections = data.results));
    },

    downloadPdf() {
      let filename = this.title.replaceAll(' ', '-').toLowerCase();
      this.$services
        .resource('projection_statistics')
        .getVarietyTotalsPdf({ 'filter[campaign]': this.campaign }, filename);
    },
  },
};
</script>
